import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'

/** Represents the view public.cable_sensor_summary_view_ */
export default interface CableSensorSummaryViewTable {
  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int8 */
  sensorCount: ColumnType<string, never, never>

  /** Database type: pg_catalog.int8 */
  calibrationCount: ColumnType<string, never, never>

  /** Database type: pg_catalog.timestamptz */
  lastCalibrationDate: ColumnType<Date, never, never>
}

export type CableSensorSummaryView = Selectable<CableSensorSummaryViewTable>

export const cableSensorSummaryView = z.object({
  cableId: cableId,
  cableSerial: z.number().nullable().optional(),
  sensorCount: z.string(),
  calibrationCount: z.string(),
  lastCalibrationDate: z.coerce.date(),
}) as unknown as z.Schema<CableSensorSummaryView>
